import React, { useState, useRef } from 'react'
import { Editor } from '../Editor/Editor'
import { useDebounce } from '../../../../hooks/useDebounce'
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon'
import Aa from './img/Aa.svg'
import selected_icon from './img/selected.svg'
import "./InformationBlock.scss"

const InformationBlock = (({
    data,
    changeContent,
    setContentArr,
    id,
    setCurrentIndex,
    ind,
    setIsModal,
    setBeforeBlock,
    before,
    readonly = false,
    addNewBlock,
}) => {
    const ref = useRef()
    const [content, setContent] = useState(data[0]?.value)
    const [showLinkModal, setShowLinkModal] = useState(false)
    const [target, setTarget] = useState(null)
    const [selectionData, setSelectionData] = useState({})
    const [isEditor, setIsEditor] = useState(false)

    const handleInput = (e) => {
        debounceChange(id,
            [
                {
                    value: ref?.current?.innerHTML,
                    properties: {}
                }
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        content: [
                            {
                                value: ref?.current?.innerHTML,
                            }
                        ]
                    }
                } else {
                    return el
                }
            })
        })
    }

    const getSelectionText = () => {
        let text = "";
        let startIndex
        let endIndex
        const WGS = window.getSelection()
        if (WGS) {
            text = WGS.toString();
            startIndex = WGS.extentOffset
            endIndex = WGS.anchorOffset
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }
        return { text, startIndex, endIndex };
    }

    const contextMenuHandler = e => {
        e.preventDefault()
        const selectionObj = getSelectionText()
        if (selectionObj?.text?.length < 1) {
            return
        }
        setSelectionData(selectionObj)
        setTarget(e.target)
        setShowLinkModal(true)
    }

    const debounceChange = useDebounce(changeContent, 1000)

    // Вставка кода без форматирования
    const handlePaste = (event) => {
        event.preventDefault();

        let clipboardData = event.clipboardData || window.clipboardData;
        let pastedHTML = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

        if (pastedHTML) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(pastedHTML, 'text/html');

            // Удаляем все теги <br>
            doc.querySelectorAll('br').forEach(el => el.remove());

            // Оставляем только безопасные теги
            const allowedTags = ['p', 'b', 'i', 'u', 'a'];
            doc.body.querySelectorAll('*').forEach(el => {
                if (!allowedTags.includes(el.tagName.toLowerCase())) {
                    el.replaceWith(...el.childNodes); // Заменяем на чистый текст
                }
            });

            let cleanHTML = doc.body.innerHTML;

            // Вставляем очищенный HTML без форматирования
            document.execCommand('insertHTML', false, cleanHTML);
        }
    }

    // Обработчик нажатия клавиш
    const handleKeyDown = (e) => {
        // Обработка Ctrl+Enter для красной строки
        if (e.ctrlKey && e.key === 'Enter') {
            e.preventDefault();
            document.execCommand('insertLineBreak')
            return
        }

        if (e.key === 'Enter') {
            e.preventDefault();
            addNewBlock();
            return
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '100%'
        }}>
            {/* <TextEditor /> */}
            {/* <TextEditor /> */}
            {!readonly &&
                (isEditor && <Editor
                    handleInput={handleInput}
                />)}


            <div className='article-text__wrapper'>
                {!readonly && <ButtonWithIcon
                    icon={Aa}
                    size='xs'
                    onClick={(e) => setIsEditor(!isEditor)}
                    style={{ marginTop: '' }}
                />}

                {!readonly && <ButtonWithIcon
                    icon={selected_icon}
                    size='xs'
                    onClick={(e) => {
                        setCurrentIndex(ind)
                        setIsModal(true)
                    }}
                    style={{ marginTop: '8px' }}
                />}

                <div className='information-article'
                    onClick={(e) => {
                        setCurrentIndex(ind)
                        setBeforeBlock(before)
                    }}
                    onKeyDown={handleKeyDown}
                    onContextMenu={(e) => {
                        if (!readonly) {
                            e.preventDefault()
                            setCurrentIndex(ind)
                            setIsModal(true)
                        }
                    }}>
                    <p
                        onPaste={handlePaste}
                        ref={ref}
                        className={`information-article__text`}
                        suppressContentEditableWarning
                        contentEditable={!readonly}
                        onInput={(e) => handleInput(e)}
                        onContextMenu={contextMenuHandler}
                        dangerouslySetInnerHTML={{ __html: content }}
                    ></p>
                </div>
            </div>
        </div>
    )
})

export { InformationBlock }